// extracted by mini-css-extract-plugin
export default {"toggle-btn":"message_toggle-btn__vclOY","toggle-btn-close":"message_toggle-btn-close__hWcmi"};